/**
 * Base class for any of the errors that can be returned.
 */
export class BaseError extends Error {
  extensionVersion: string | undefined

  /**
   * Creates an instance of BaseError.
   * @param message - Error message.
   * @param extensionVersion - Version of the extension where the error occurred.
   */
  constructor(
    message: string = '',
    extensionVersion: string | undefined = undefined
  ) {
    super(message)
    this.extensionVersion = extensionVersion
  }
}
